module.exports = __webpack_public_path__ + "img/20.0a7f5484.jpg";